/**
 * @license hugeicons-react v0.1.3
 *
 * See the LICENSE file in the root directory of this source tree.
 */

import r from"../create-hugeicon-component.js";const e=r("HelpCircleIcon",[["circle",{cx:"12",cy:"12",r:"10",stroke:"currentColor",key:"k0"}],["path",{d:"M10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 9.39815 13.8837 9.76913 13.6831 10.0808C13.0854 11.0097 12 11.8954 12 13V13.5",stroke:"currentColor",key:"k1"}],["path",{d:"M11.992 17H12.001",stroke:"currentColor",key:"k2"}]]);export{e as default};
